import _isEmpty from 'lodash/isEmpty';

// Инициализируем город, версию сайта и юзерайди ---- НЕ ИСПОЛЬЗУЕТСЯ
export function getInitialData(action, prevState, nextState) {
  const { user, city } = nextState;

  const outData = {
    websiteVersion: 'Версия 2.0',
  };

  if (user.profile && user.profile.id) {
    outData.userID = user.profile.id;
  }

  if (city && city.userCity) {
    outData.UserCity = city.userCity.name;
  }

  return outData;
}

// Смена города
export function cityChange(action, prevState, nextState) {
  const actionPayloadCityName = ((action || {}).payload || {}).name;
  const prevUserCityDataName = (((prevState || {}).city || {}).userCity || {}).name;

  if (
    _isEmpty(actionPayloadCityName) ||
    _isEmpty(prevUserCityDataName) ||
    prevUserCityDataName === actionPayloadCityName
  ) {
    return null;
  }

  const outData = {
    event: 'UA event',
    eventCategory: 'Выбор города',
    eventAction: actionPayloadCityName,
    eventLabel: undefined,
    UserCity: actionPayloadCityName,
  };

  return outData;
}

// Смена языка
export function localeChange(action, prevState, nextState) {
  let eventAction = '';
  let UserLanguage = '';

  if (action.payload) {
    if (action.payload === 'en') {
      eventAction = 'На английский';
      UserLanguage = 'Английский';
    } else if (action.payload === 'ru') {
      eventAction = 'На русский';
      UserLanguage = 'Русский';
    }
  }

  const outData = {
    event: 'UA event',
    eventCategory: 'Переключение языка',
    eventAction: eventAction,
    eventLabel: undefined,
    UserLanguage: UserLanguage,
  };

  return outData;
}

// Добавление действительного промокода
export function applyStock(action, prevState, nextState) {
  const {
    type,
    payload: { code, error },
    badStock,
    status,
  } = action;
  const _success = type === '@stock/APPLY_STOCK_SUCCESS';

  if (_success) {
    const prevStockDataCode = (((prevState || {}).stock || {}).data || {}).code;

    if (!_isEmpty(prevStockDataCode) && prevStockDataCode === code) {
      return null;
    }
  }

  const outData = {
    event: 'UA event',
    eventCategory: 'Активация промокода',
    eventAction: 'Вручную',
    eventLabel: _success ? code : status === 404 || status === 400 ? badStock : error,
    promoValidity: _success ? 'Действителен' : 'Недействителен',
  };

  return outData;
}
